export default {
    LAU: 'LAU',
    LAS: 'LAS',
    CELLULAR: 'Cellular',
    WI_FI: 'Wi-Fi',
};
